import { createStudentIdentityResolver } from "./studentIdentityStore";

const EXPORT_LINK_SELECTOR = "a[data-student-mask-export]";
const IDENTIFIER_SELECTOR = "[data-student-mask-export-id]";
const PAYLOAD_PARAM = "student_masks";
const MAX_MASKS = 500;

function collectIdentifiers(root) {
  const identifiers = new Set();
  const scope = root instanceof Element ? root : document;

  scope.querySelectorAll(IDENTIFIER_SELECTOR).forEach((element) => {
    const identifier = String(element.getAttribute("data-student-mask-export-id") ?? "").trim();
    if (identifier) {
      identifiers.add(identifier);
    }
  });

  return Array.from(identifiers).slice(0, MAX_MASKS);
}

function buildMaskPayload(schoolId, identifiers) {
  const resolver = createStudentIdentityResolver();
  const entries = resolver.getEntriesForSchool(schoolId);
  const payload = {};

  identifiers.forEach((identifier) => {
    const maskedName = String(entries[identifier] ?? "")
      .replace(/\s+/g, " ")
      .trim();
    if (maskedName) {
      payload[identifier] = maskedName;
    }
  });

  return payload;
}

function submitExport(link, payload, csrfToken) {
  const url = new URL(link.href, window.location.href);
  url.searchParams.delete(PAYLOAD_PARAM);

  const form = document.createElement("form");
  form.method = "post";
  form.action = url.toString();
  form.target = link.target || "_self";
  form.rel = "noopener noreferrer";
  form.hidden = true;

  Object.entries({ [PAYLOAD_PARAM]: JSON.stringify(payload), _csrf: csrfToken }).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  form.remove();
}

function handleExportClick(event) {
  const link = event.currentTarget;
  if (!(link instanceof HTMLAnchorElement)) {
    return;
  }

  const root =
    link.closest("[data-student-mask-export-root]") || document.querySelector("[data-student-mask-export-root]");
  const schoolId = String(link.getAttribute("data-school-id") || root?.getAttribute("data-school-id") || "").trim();

  if (!schoolId) {
    return;
  }

  const identifiers = collectIdentifiers(root);
  const payload = buildMaskPayload(schoolId, identifiers.length > 0 ? identifiers : collectIdentifiers(document));
  const url = new URL(link.href, window.location.href);
  url.searchParams.delete(PAYLOAD_PARAM);
  link.href = url.toString();

  if (Object.keys(payload).length === 0) {
    return;
  }

  event.preventDefault();
  submitExport(link, payload, root?.getAttribute("data-csrf-token") || "");
}

export function initStudentMaskExportLinks(root = document) {
  const scope = root instanceof Element || root instanceof Document ? root : document;

  scope.querySelectorAll(EXPORT_LINK_SELECTOR).forEach((link) => {
    if (!(link instanceof HTMLAnchorElement) || link.dataset.studentMaskExportBound === "1") {
      return;
    }

    link.dataset.studentMaskExportBound = "1";
    link.addEventListener("click", handleExportClick);
  });
}
